"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConceptOfferHintTranslations = void 0;
var _culture = require("@ori/culture");
var _react = require("react");
var _useTranslations = require("./useTranslations");
const useConceptOfferHintTranslations = (param)=>{
    let { benefitsQuantity, discountPercent, requiredQuantity } = param;
    const { formatMessage } = (0, _useTranslations.useTranslations)();
    const { culture } = (0, _culture.useCulture)();
    const formattedPrecentDiscount = discountPercent === null ? undefined : (0, _culture.formatPercent)(discountPercent, culture, {
        decimals: _culture.Decimals.None
    });
    const chooseTitle = formatMessage('choose');
    const buyProductsTitle = (0, _react.useMemo)(()=>formatMessage('buyProducts', {
            0: requiredQuantity
        }), [
        requiredQuantity,
        formatMessage
    ]);
    const getOfferTitle = formatMessage('getOffer');
    const chooseUpToTitle = (0, _react.useMemo)(()=>formatMessage('chooseUpTo0ProductsWith1Discount', {
            0: benefitsQuantity,
            1: formattedPrecentDiscount
        }), [
        benefitsQuantity,
        formattedPrecentDiscount,
        formatMessage
    ]);
    return {
        buyProductsTitle,
        chooseTitle,
        chooseUpToTitle,
        formattedPrecentDiscount,
        getOfferTitle
    };
};
exports.useConceptOfferHintTranslations = useConceptOfferHintTranslations;
